import React, { useEffect, useMemo, useState } from "react";
import CautionIcon from "../../../assets/icons/ABHA-icons/caution-icon";
import InputField from "../../forms/input-field";
import { Field, Form, Formik, useFormikContext } from "formik";
import AddButton from "../../buttons/button";
import * as Yup from "yup";
import errorToast from "../../helper-components/error-toast";
import { handleShowErrorToast } from "../../helper-components/helper-function";
import { accessTokenAction } from "../../../redux/actions/admin-customer-action";
import { useDispatch } from "react-redux";
import successToast from "../../helper-components/success-toast";
import axios from "axios";
import { url } from "../../../redux/config";
import LeftArrowIcon from "../../../assets/icons/ABHA-icons/left-arrow-icon";
import { RefreshCw } from "lucide-react";

function Mobile({
  setmessage,
  closeModal,
  setTxnId,
  setMethod,
  setStatus,
  setPosition,
  setAdhaarNo,
  setAdhaarAccessToken,
  setAdhaarTokenExpiresIn,
}) {
  const dispatch = useDispatch();
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [captchaText, setCaptchaText] = useState("");

  const initialValues = {
    mobile: "",
    consent: false,
    captcha: "",
  };

  const validationSchema = Yup.object().shape({
    mobile: Yup.string()
      .required("Please your 10 digit digit Mobile number")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
    consent: Yup.boolean()
      .oneOf([true], "Please select the condition")
      .required("Please select the condition"),
    captcha: Yup.string()
      .required("Please enter the CAPTCHA")
      .test("is-captcha-correct", "Captcha is incorrect", function () {
        const { captcha } = this.options.context; // get from Formik context
        return captcha === captchaText;
      }),
  });

  const onTokenFail = (data) => {
    setLoading(false);
    errorToast(data.message);
  };
  const sendOtpWithAadhaar = async (data, mobile) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${url}/abha-integration/abha-create-enrollment-via-dl-send-otp`,
        {
          mobileNumber: JSON.stringify(mobile),
          accessToken: data,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", response);
      successToast("OTP is sent");
      setTxnId(response?.data?.data?.abdmResponse?.txnId);
      setmessage(response?.data?.data?.abdmResponse?.message);
      console.log(response?.data?.data?.abdmResponse?.message);
      setStatus("OTP Verification");
      setPosition(2);

      setLoading(false);
      //   setPopUp(true);

      return response.data;
    } catch (error) {
      errorToast(error.response?.data || error.message);
      console.error(
        "Error sending OTP:",
        error.response?.data || error.message
      );
      setLoading(false);
      // throw error;
    }
  };
  const handleCaptchaChange = (verified, value) => {
    setCaptchaVerified(verified);
  };
  const onsave = (values) => {
    // setLoading(true);
    dispatch(
      accessTokenAction((data) => {
        setAdhaarNo(values.mobile);

        setAdhaarAccessToken(data?.data?.sessionToken?.accessToken);
        setAdhaarTokenExpiresIn(data?.data?.sessionToken?.expiresIn);
        sendOtpWithAadhaar(
          data?.data?.sessionToken?.accessToken,
          values.mobile
        );

        // sendOtpWithAadhaar(data?.data?.sessionToken?.accessToken);
        // setAccessToken(data?.data?.sessionToken?.accessToken);
        // setPopUp(true);
        // setLoading(false);
      }, onTokenFail)
    );
  };
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onsave}
      context={{ captchaText }}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form className="flex flex-col h-full">
          <div className="flex-1 flex flex-col gap-6 mt-6">
            <div
              onClick={() => {
                setStatus("Method Selection");
                setPosition(0);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              className="flex flex-row gap-2 items-center cursor-pointer "
            >
              <LeftArrowIcon />
              <label
                className={`
                cursor-pointer text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-button-fw)] whitespace-nowrap`}
              >
                Back
              </label>
            </div>
            <label
              className={`
                 text-[length:var(--abha-method-title2-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
            >
              Enter Mobile Number
            </label>

            <div className="flex flex-col gap-2">
              <InputField
                type="number"
                errMsgContainerClass="hidden"
                maxLength={10}
                labelClass={` text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-fw)] w-full`}
                parentClass="flex  flex-col gap-2 w-full align-end "
                name="mobile"
                placeholder="0000000000"
                label="Mobile Number"
                //     defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)]
                //   `}
                isRequired={true}
                containerClass="w-full h-min"
              />
              <label
                className={`text-[var(--abha-nav-fg)] 
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] `}
              >
                Enter your 10-digit mobile number
              </label>
            </div>
            <CaptchaInput
              captchaText={captchaText}
              setCaptchaText={setCaptchaText}
              onCaptchaChange={handleCaptchaChange}
            />
            <div className="p-[10px]  flex gap-3 border border-[var(--abha-nav-bg)] rounded-lg">
              {/* <input type="checkbox" className="mb-auto mt-2" /> */}
              <Field type="checkbox" name="consent" className="mb-auto mt-1" />
              <label
                className={`text-[var(--abha-nav-fg)] leading-[23px]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] `}
              >
                I agree to share my Aadhaar details for ABHA creation as per
                ABDM guidelines. This information will be used solely for the
                purpose of creating your ABHA number and will be handled in
                accordance with data protection regulations.
              </label>
            </div>
            <div className="border bg-[var(--abha-caution-bg)] border-[var(--primary)] rounded-lg flex flex-row gap-[10px] p-[10px]">
              <CautionIcon />
              <label
                className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] `}
              >
                Your Aadhaar number will be securely encrypted before
                submission. We follow strict security protocols to protect your
                personal information.
              </label>
            </div>
            <div
              style={{
                bottom: "0",
              }}
              className="flex flex-row gap-3 justify-end  sticky bg-white py-4 mt-auto "
            >
              <AddButton
                prefixIcon={false}
                // ref={submitRef}
                onclkFn={() => closeModal()}
                text={<span>Cancel</span>}
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                type="button"
              />
              <AddButton
                prefixIcon={false}
                loading={loading}
                // ref={submitRef}
                onclkFn={() => handleShowErrorToast(errors)}
                text={<span>Send OTP</span>}
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                type="submit"
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

const CaptchaInput = ({
  captchaText,
  setCaptchaText,
  onCaptchaChange,
  className = "",
}) => {
  const [userInput, setUserInput] = useState("");
  const [isVerified, setIsVerified] = useState(null);
  const [captchaKey, setCaptchaKey] = useState(0); // Key to force regeneration
  // const { values } = useFormikContext;
  // Generate random CAPTCHA text with mixed case and distortion
  const generateCaptcha = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(result);
    setUserInput("");
    setIsVerified(null);
    setCaptchaKey((prev) => prev + 1); // Force regeneration of noise
    if (onCaptchaChange) {
      onCaptchaChange(false, "");
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setUserInput(value);

    // Case-insensitive verification
    const verified =
      value.length > 0 &&
      captchaText.length > 0 &&
      value.toLowerCase() === captchaText.toLowerCase();
    setIsVerified(verified);

    if (onCaptchaChange) {
      onCaptchaChange(verified, value);
    }
  };

  // Memoize noise points so they don't regenerate on every render
  const noisePoints = useMemo(() => {
    const points = [];
    for (let i = 0; i < 50; i++) {
      points.push({
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 2 + 1,
      });
    }
    return points;
  }, [captchaKey]); // Only regenerate when captchaKey changes

  // Memoize character transformations
  const characterStyles = useMemo(() => {
    return captchaText.split("").map(() => ({
      transform: `rotate(${(Math.random() - 0.5) * 30}deg) translateY(${
        (Math.random() - 0.5) * 8
      }px)`,
      color: `hsl(${Math.random() * 60}, 30%, 20%)`,
    }));
  }, [captchaText]); // Only regenerate when captchaText changes
  // const {values,}
  return (
    <div className={`w-full ${className}`}>
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Captcha
        </label>

        <div className="flex items-center gap-2">
          {/* CAPTCHA Image Container */}
          <div
            className="relative bg-gray-200 border border-gray-300 rounded-sm overflow-hidden"
            style={{ width: "150px", height: "60px" }}
          >
            {/* Background noise pattern */}
            <div
              className="absolute inset-0"
              style={{
                background: `
                  radial-gradient(circle at 20% 20%, rgba(0,0,0,0.1) 1px, transparent 1px),
                  radial-gradient(circle at 80% 40%, rgba(0,0,0,0.1) 1px, transparent 1px),
                  radial-gradient(circle at 40% 80%, rgba(0,0,0,0.1) 1px, transparent 1px),
                  linear-gradient(45deg, rgba(0,0,0,0.05) 1px, transparent 1px),
                  linear-gradient(-45deg, rgba(0,0,0,0.05) 1px, transparent 1px)
                `,
                backgroundSize:
                  "10px 10px, 15px 15px, 12px 12px, 8px 8px, 8px 8px",
              }}
            />

            {/* Noise lines */}
            <svg
              className="absolute inset-0 w-full h-full"
              style={{ zIndex: 1 }}
            >
              <defs>
                <pattern
                  id="noisePattern"
                  patternUnits="userSpaceOnUse"
                  width="4"
                  height="4"
                >
                  <rect width="4" height="4" fill="transparent" />
                  <circle cx="2" cy="2" r="0.5" fill="rgba(0,0,0,0.3)" />
                </pattern>
              </defs>

              {/* Static noise lines - these won't change */}
              <line
                x1="10"
                y1="15"
                x2="140"
                y2="25"
                stroke="rgba(0,0,0,0.4)"
                strokeWidth="1"
              />
              <line
                x1="5"
                y1="35"
                x2="145"
                y2="20"
                stroke="rgba(0,0,0,0.3)"
                strokeWidth="1"
              />
              <line
                x1="20"
                y1="45"
                x2="130"
                y2="35"
                stroke="rgba(0,0,0,0.3)"
                strokeWidth="1"
              />
              <line
                x1="0"
                y1="50"
                x2="150"
                y2="10"
                stroke="rgba(0,0,0,0.2)"
                strokeWidth="1"
              />

              {/* Memoized noise dots */}
              {noisePoints.map((point, index) => (
                <circle
                  key={`${captchaKey}-${index}`}
                  cx={`${point.x}%`}
                  cy={`${point.y}%`}
                  r={point.size}
                  fill="rgba(0,0,0,0.2)"
                />
              ))}

              {/* Static distortion lines */}
              <path
                d="M0,30 Q30,20 60,35 T120,25 T150,40"
                stroke="rgba(0,0,0,0.3)"
                strokeWidth="1"
                fill="none"
              />
            </svg>

            {/* CAPTCHA Text */}
            <div className="absolute inset-0 flex items-center justify-center z-10">
              <span
                className="font-bold text-gray-800 select-none tracking-wider"
                style={{
                  fontSize: "18px",
                  textShadow:
                    "1px 1px 2px rgba(255,255,255,0.8), -1px -1px 1px rgba(0,0,0,0.3)",
                  transform: "skew(-5deg) rotate(-2deg)",
                  fontFamily: "Arial, sans-serif",
                  letterSpacing: "2px",
                }}
              >
                {captchaText.split("").map((char, index) => (
                  <span
                    key={`${captchaText}-${index}`}
                    style={{
                      display: "inline-block",
                      ...characterStyles[index],
                    }}
                  >
                    {char}
                  </span>
                ))}
              </span>
            </div>
          </div>

          {/* Refresh Button */}
          <button
            type="button"
            onClick={generateCaptcha}
            className="p-2 text-blue-500 hover:text-blue-700 transition-colors"
            title="Refresh CAPTCHA"
          >
            <RefreshCw size={18} />
          </button>
        </div>
      </div>

      {/* Input Field */}
      <div>
        <InputField
          name="captcha"
          label="Captcha"
          type="text"
          maxLength={6}
          value={userInput}
          // onChange={handleInputChange}
          placeholder="Enter Captcha"
          handleChange={handleInputChange}
          // className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
          // style={{ backgroundColor: "#f9f9f9" }}
          errMsgContainerClass="hidden"
          labelClass={` text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-fw)] w-full`}
          parentClass="flex  flex-col gap-2 w-full align-end "
          isRequired={true}
          containerClass="w-full h-min"
        />
        {/* <InputField
        /> */}
      </div>
    </div>
  );
};

export default Mobile;
